import { Alert, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { translateApiError, type ApiQueryError } from '@/shared/api/errorToMessage';

export interface QueryErrorAlertProps {
  error: ApiQueryError;
  onRetry: () => void;
  /** `warning` for a failed background refresh while cached data is still shown. */
  type?: 'error' | 'warning';
}

/** Inline «failed to load» notice with a retry button — instead of pretending the list is empty. */
export function QueryErrorAlert({ error, onRetry, type = 'error' }: QueryErrorAlertProps) {
  const { t } = useTranslation('common');
  return (
    <Alert
      type={type}
      showIcon
      message={translateApiError(error)}
      action={
        <Button size="small" onClick={onRetry}>
          {t('error.boundary.retry')}
        </Button>
      }
    />
  );
}
